export const EXPORT_BUTTON_LABEL = 'Export';
export const TOOLTIP_MESSAGE = 'Results are unavailable because analysis was run on a previous version of UK Biobank.';
